module.exports = __webpack_public_path__ + "97a23d8897cec6e16e87ea860382e908.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/name-female-3.svg
// module id = 84
// module chunks = 0